exports = module.exports = require("../../../css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".footerCon[data-v-be1f7bf6] {\n  display: flex;\n  justify-content: space-between;\n  margin: 0 20px 20px;\n}", ""]);

// exports
